















































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import {
    Inspiration,
    InspirationArticle,
    InspirationHotspotImage
} from '@/models/Inspiration';
@Component
export default class ImageHotspots extends Vue {
    @Prop()
    protected inspiration!: Inspiration;
    @Prop()
    protected initialImage!: InspirationHotspotImage;

    protected hoverItem: string = '';
    protected activeImage: InspirationHotspotImage = {} as InspirationHotspotImage;
    protected activeArticles: InspirationArticle[] = {} as InspirationArticle[];

    constructor() {
        super();
    }

    created() {
        this.activeImage = this.initialImage;
        if (this.activeImage) {
            this.setActiveArticles();
        }
    }

    private setActiveArticles() {
        const result = this.inspiration.articles.filter(x =>
            this.activeImage.entityIds.includes(x.entityId)
        );
        this.activeArticles = result;
    }

    private mouseOver(variantnr: any) {
        this.hoverItem = variantnr;
    }
    private mouseLeave() {
        this.hoverItem = '';
    }
    private close() {
        this.$emit('close');
    }

    private setHotSpot(hotspot: any) {
        if (hotspot.type === 'spot') {
            const coords = hotspot.coords.split(',');
            if (coords.length > 1) {
                const x = Math.round(coords[0] * 100 * 100) / 100;
                const y = Math.round(coords[1] * 100 * 100) / 100;
                return `top:${y}%;left:${x}%;`;
            }
        } else {
            return 'display:none;';
        }
    }
    private selectedImage(image: InspirationHotspotImage) {
        this.activeImage = image;
        this.setActiveArticles();
    }
}
